import * as tslib_1 from "tslib";
import selectMarkAsReadOption from '../actions/selectMarkAsReadOption';
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
var MarkAsReadFull = /** @class */ (function (_super) {
    tslib_1.__extends(MarkAsReadFull, _super);
    function MarkAsReadFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            selectMarkAsReadOption(option.key);
        };
        return _this;
    }
    MarkAsReadFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var behavior = getFallbackValueIfNull(optionStore.behavior, userOptions.PreviewMarkAsRead);
        var delay = getFallbackValueIfNull(optionStore.delay, userOptions.MarkAsReadDelaytime);
        var selectedKey = behavior === 'Delayed' && delay === 0 ? 'Instant' : behavior;
        var choices = [
            {
                key: 'Instant',
                text: strings.options_mail_markAsReadInstant,
            },
            {
                key: 'Delayed',
                // TODO: VSO:13206 -Need to make a change to Fabric to allow for a dropdown inline as part of a choice
                // https://github.com/OfficeDev/office-ui-fabric-react/issues/1765
                text: strings.options_mail_markAsReadDelayed,
            },
            {
                key: 'OnSelectionChange',
                text: strings.options_mail_markAsReadSelectionChange,
            },
            {
                key: 'Never',
                text: strings.options_mail_markAsReadNever,
            },
        ];
        return React.createElement(ChoiceGroup, { selectedKey: selectedKey, options: choices, onChange: this.onChange });
    };
    MarkAsReadFull = tslib_1.__decorate([
        reactive({
            optionStore: function () { return store; },
            userOptions: function () { return getUserConfiguration().UserOptions; },
        })
    ], MarkAsReadFull);
    return MarkAsReadFull;
}(React.Component));
export default MarkAsReadFull;
//# sourceMappingURL=MarkAsReadFull.js.map